document.addEventListener("DOMContentLoaded", () => {
  const confirmables = document.querySelectorAll("[data-confirm]");

  confirmables.forEach((el) => {
    const submitEvent = (el instanceof HTMLFormElement) ? 'submit' : 'click';

    el.addEventListener(submitEvent, (e) => {
      const data = el.dataset;

      if (data.confirmIf && data.confirmIf === "false") {
        return;
      }

      if (!confirm(data.confirm)) {
        e.preventDefault();
      }
    });
  })
});
